import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const EngagementRingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.53033 23.9697C7.82322 24.2626 7.82322 24.7374 7.53033 25.0303L6.37648 26.1842C6.08359 26.4771 5.60872 26.4771 5.31582 26.1842C5.02293 25.8913 5.02293 25.4164 5.31582 25.1235L6.46967 23.9697C6.76256 23.6768 7.23744 23.6768 7.53033 23.9697Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68267 27.8159C3.97557 28.1087 3.97557 28.5836 3.68267 28.8765L2.52883 30.0304C2.23593 30.3233 1.76106 30.3233 1.46817 30.0304C1.17527 29.7375 1.17527 29.2626 1.46817 28.9697L2.62201 27.8159C2.91491 27.523 3.38978 27.523 3.68267 27.8159Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.46783 23.9697C1.76072 23.6768 2.2356 23.6768 2.52849 23.9697L3.68234 25.1235C3.97523 25.4164 3.97523 25.8913 3.68234 26.1842C3.38944 26.4771 2.91457 26.4771 2.62168 26.1842L1.46783 25.0303C1.17494 24.7374 1.17494 24.2626 1.46783 23.9697Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.31549 27.8159C5.60838 27.523 6.08325 27.523 6.37615 27.8159L7.52999 28.9697C7.82289 29.2626 7.82289 29.7375 7.52999 30.0304C7.2371 30.3233 6.76223 30.3233 6.46933 30.0304L5.31549 28.8765C5.02259 28.5836 5.02259 28.1088 5.31549 27.8159Z"
          fill="#006DFF"
        />
        <path
          d="M20 4.5C20 3.94772 20.4477 3.5 21 3.5C21.5523 3.5 22 3.94772 22 4.5C22 5.05228 21.5523 5.5 21 5.5C20.4477 5.5 20 5.05228 20 4.5Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4697 7.53034C24.1768 7.23745 24.1768 6.76257 24.4697 6.46968L25.6235 5.31583C25.9164 5.02294 26.3913 5.02294 26.6842 5.31583C26.9771 5.60873 26.9771 6.0836 26.6842 6.37649L25.5303 7.53034C25.2374 7.82323 24.7626 7.82323 24.4697 7.53034Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3173 3.68415C28.0244 3.39125 28.0244 2.91638 28.3173 2.62349L29.4712 1.46964C29.7641 1.17675 30.2389 1.17675 30.5318 1.46964C30.8247 1.76253 30.8247 2.23741 30.5318 2.5303L29.378 3.68415C29.0851 3.97704 28.6102 3.97704 28.3173 3.68415Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5322 7.53033C30.2393 7.82322 29.7644 7.82322 29.4715 7.53033L28.3177 6.37648C28.0248 6.08359 28.0248 5.60872 28.3177 5.31582C28.6106 5.02293 29.0854 5.02293 29.3783 5.31582L30.5322 6.46967C30.8251 6.76256 30.8251 7.23744 30.5322 7.53033Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6845 3.68414C26.3916 3.97703 25.9167 3.97703 25.6239 3.68414L24.47 2.53029C24.1771 2.2374 24.1771 1.76253 24.47 1.46963C24.7629 1.17674 25.2378 1.17674 25.5307 1.46963L26.6845 2.62348C26.9774 2.91637 26.9774 3.39125 26.6845 3.68414Z"
          fill="#006DFF"
        />
        <path
          d="M7 1.92308L9.49998 1H14.4999L16.9999 1.92308L17 4.69231L13.6667 6.20093L12 7L10.3334 6.20093L7.00008 4.69231L7 1.92308Z"
          fill="#E4E0FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6667 6.20093L17 4.69231L16.9999 1.92308L14.4999 1H9.49998L7 1.92308L7.00008 4.69231L10.3334 6.20093L12 7L13.6667 6.20093ZM12 5.33651L13.0331 4.8412L15.5 3.72473L15.5 2.96822L14.2319 2.5H9.76806L8.50003 2.9682L8.50005 3.7247L10.9669 4.8412L12 5.33651Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.66475 1.32922C10.0352 1.14398 10.4857 1.29415 10.671 1.66463L12.0002 4.32299L13.3293 1.66463C13.5146 1.29415 13.9651 1.14398 14.3356 1.32922C14.7061 1.51446 14.8562 1.96497 14.671 2.33545L12.671 6.33545C12.5439 6.58954 12.2842 6.75004 12.0002 6.75004C11.7161 6.75004 11.4564 6.58954 11.3293 6.33545L9.32934 2.33545C9.1441 1.96497 9.29427 1.51446 9.66475 1.32922Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 29.5C23.6944 29.5 27.5 25.6944 27.5 21C27.5 16.3056 23.6944 12.5 19 12.5C14.3056 12.5 10.5 16.3056 10.5 21C10.5 25.6944 14.3056 29.5 19 29.5ZM19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 26.5C22.0376 26.5 24.5 24.0376 24.5 21C24.5 17.9624 22.0376 15.5 19 15.5C15.9624 15.5 13.5 17.9624 13.5 21C13.5 24.0376 15.9624 26.5 19 26.5ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3288 23.6912C19.1288 22.405 21.9773 17.4712 20.6911 12.6712C19.405 7.8712 14.4712 5.02267 9.6712 6.30882C4.8712 7.59498 2.02267 12.5288 3.30882 17.3288C4.59498 22.1288 9.52878 24.9773 14.3288 23.6912ZM13.5525 20.7941C16.7525 19.9367 18.6515 16.6475 17.7941 13.4475C16.9367 10.2475 13.6475 8.34844 10.4475 9.20588C7.24746 10.0633 5.34844 13.3525 6.20588 16.5525C7.06331 19.7525 10.3525 21.6515 13.5525 20.7941Z"
          fill="#C0AAFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1643 19.3452C15.5641 18.7022 16.9883 16.2355 16.3452 13.8357C15.7022 11.4359 13.2355 10.0117 10.8357 10.6548C8.4359 11.2978 7.01175 13.7645 7.65477 16.1643C8.2978 18.5641 10.7645 19.9883 13.1643 19.3452ZM13.5525 20.7941C16.7525 19.9367 18.6516 16.6475 17.7941 13.4475C16.9367 10.2475 13.6475 8.34844 10.4475 9.20588C7.24747 10.0633 5.34845 13.3525 6.20588 16.5525C7.06332 19.7525 10.3525 21.6516 13.5525 20.7941Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9406 22.2423C17.9404 21.1705 20.314 17.0592 19.2423 13.0594C18.1705 9.05963 14.0592 6.68597 10.0594 7.75771C6.05963 8.82946 3.68597 12.9408 4.75771 16.9406C5.82946 20.9404 9.94076 23.314 13.9406 22.2423ZM14.3288 23.6912C19.1288 22.405 21.9773 17.4712 20.6912 12.6712C19.405 7.8712 14.4712 5.02267 9.67121 6.30882C4.8712 7.59498 2.02267 12.5288 3.30882 17.3288C4.59498 22.1288 9.52879 24.9773 14.3288 23.6912Z"
          fill="#0F3893"
        />
        <mask
          id="mask0_7268_96847"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="14"
          y="11"
          width="8"
          height="5"
        >
          <rect x="14" y="11" width="8" height="5" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7268_96847)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 29.5C23.6944 29.5 27.5 25.6944 27.5 21C27.5 16.3056 23.6944 12.5 19 12.5C14.3056 12.5 10.5 16.3056 10.5 21C10.5 25.6944 14.3056 29.5 19 29.5ZM19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 26.5C22.0376 26.5 24.5 24.0376 24.5 21C24.5 17.9624 22.0376 15.5 19 15.5C15.9624 15.5 13.5 17.9624 13.5 21C13.5 24.0376 15.9624 26.5 19 26.5ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
            fill="#0F3893"
          />
        </g>
      </svg>
    );
  }
);

export default EngagementRingIcon;
